/* eslint-disable @typescript-eslint/ban-ts-ignore */
import { SET_LAUNCH_OFFERS_PARAMETER } from '../actions/actionTypes';
//@ts-ignore
import objectPath from 'object-path';
import { AlightStateType } from '../../../types/alight-state';

export default function welcomeUserLaunchOfferParamReducer(state = {}, action: any) {
    let newState;
    switch (action.type) {
        case SET_LAUNCH_OFFERS_PARAMETER:
            {
            newState = Object.assign({}, state);
        //@ts-ignore
            let offers = state.LaunchOffers;

            if(offers === undefined){
                offers = [action.offer];
            }
            else if(!offers.includes(action.offer)){
                offers.push(action.offer);
            }

            objectPath.set(newState, 'LaunchOffers', offers);

            return newState;
        }
        default:{
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./modules/launch-offers-post-message-handling/reducers/welcomeUserReducer.ts